module.exports = __webpack_public_path__ + "static/c16-9c40ad3ebb12616331bb6da343d36c3b.jpg";